import React from "react";

export default function OneIsToOne() {
  return (
    <div className="overflow-hidden rounded-lg aspect-square">
      <div className="flex h-full w-full items-center justify-center bg-gray-100 text-sm text-gray-600 dark:bg-gray-800 dark:text-gray-300">
        Conteudo de video externo removido por privacidade.
      </div>
    </div>
  );
}
